// extracted by mini-css-extract-plugin
module.exports = {"facebookContainer":"Facebook_facebookContainer__V0U2Z"};